import React, { useRef, useState } from "react";
const DMVideoItem = ({ src }) => {
  const videoPlayer = useRef(null);
  const [showPlayIcon, setShowPlayIcon] = useState(true);
  const handleVideoPlay = () => {
    if (videoPlayer.current) {
      setShowPlayIcon(false);
      videoPlayer.current.play();
    }
  };
  return (
    <div className="selfie">
      <video
        ref={videoPlayer}
        src={src}
        preload={"auto"}
        controlsList="nodownload noremoteplayback"
        playsInline
        controls={showPlayIcon ? false : true}
      />

      {showPlayIcon ? (
        <div className="playIcon" onClick={handleVideoPlay}>
          <i className="icon-play" />
        </div>
      ) : null}
    </div>
  );
};

export default DMVideoItem;
